import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import Header from '../components/book/Header'
import StartTrial from '../components/home/StartTrial'
import FAQ from '../components/book/FAQ'
import Logo from '../components/home/Logo'
import styled from 'styled-components'
import Container from '../components/home/styles/Container'
import '../styles.less'
import Layout from '../layouts/index'
import SignUp from '../components/book/SignUp'

const FAQBackground = styled.div`
  z-index: -3;

  position: absolute;
  left: 50%;
  width: 50%;
  margin-top: 20rem;

  overflow: hidden;
`

const LargeText = styled.div`
  font-size: 1.5em;

  margin: 1em auto 3em;
`

class Home extends React.Component {
  render() {
    return (
      <Layout>

        <Helmet title={'The Ultimate Guide to Quora Marketing by Find Better Questions (2019)'} />

        <Header/>

        <SignUp/>

        <Container>
          <p>
            I’m Emil, the founder of <Link to="/">Find Better Questions</Link>. While building a tool that helps marketers get the most out of answering questions on Quora, I figured out that many people struggle with finding the right strategy.
          </p>
          <LargeText>
            Having read and listened to 100+ resources on the topic, I know that it’s not too easy to get big on Quora. Even when starting seems easy and resources are widely available, having success is a different game. <br/>
          </LargeText>
          <p>
            Because I want the users of <Link to="/">this software</Link> to have success on the platform, I bundled all my knowledge into a single book.
          </p>
          <p>
            The best part: You can also have it.
            It’s free and available now.
          </p>
          <a style={{boxShadow: 'none'}} href="https://www.producthunt.com/posts/the-ultimate-guide-to-quora-marketing?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-the-ultimate-guide-to-quora-marketing" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=151105&theme=light" alt="The Ultimate Guide to Quora Marketing - Get traffic by answering questions | Product Hunt Embed" style={{width: '250px', height: '54px',}} width="250px" height="54px" /></a>
        </Container>

        <SignUp/>

        <Container>
          <LargeText style={{margin: '1.5em auto 5em'}}>If you’re super interested in Quora Marketing, you can also check out my Quora question searching tool.</LargeText>
        </Container>


        <StartTrial position="top" text="Find The Best Questions. Receive more traffic. Download the app now."/>


        <FAQBackground>
          <Logo size="70rem" color="#FFF8E8"/>
        </FAQBackground>
        <FAQ/>

        <div style={{ textAlign: 'center' }}>
          © 2019 Find Better Questions<br/>
          Quora is a registered trademark of Quora Inc.<br/>
          Find Better Questions is not affiliated with Quora.
        </div>
      </Layout>
    )
  }
}

export default Home
